import { SingService } from "app/components/service/sing.service";
import { Injectable, ElementRef } from "@angular/core";

@Injectable()
export class DashboardUpMenu {
    dealerGroupId: number;
    constructor(private httpService: SingService,private elRef: ElementRef) {

    }
    public getDashboard() {
        return  this.httpService
        .getDashboard(this.dealerGroupId);
    }
    public SelectDashboard (i: number, event: any) {
        let top_left_item = this.elRef.nativeElement.querySelectorAll(".top_left_item");
        for (let u = 0; u < top_left_item.length; u++) {
            top_left_item[u].classList.remove("m--active");
        }

        event.target.classList.add("m--active");
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dashboard/up-menu/services/dashboard-up-menu.service.ts